import React from 'react';
import styled from '@emotion/styled';

export const IconMisc = () => {
  return (
    <StyledIconMiscSpan className="icon-svg IconMisc">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <defs />
        <g className="a">
          <rect className="b" width="24" height="24" />
          <path
            className="c"
            d="M15.56,9.5A1.989,1.989,0,0,1,12.6,10.782c-1.332-.681-7.763-4.225-9.62-4.544C1.366,5.96.923,7.337.583,8.26s-1.793,6.7,1.753,7.292a38.327,38.327,0,0,0,8.721.341c1.914-.163,2.669-1.29,3.183-2.732C14.727,11.79,19,0,19,0"
            transform="translate(2.5 4.5)"
          />
        </g>
      </svg>
    </StyledIconMiscSpan>
  );
};

const StyledIconMiscSpan = styled.span`
  & .a {
    opacity: 0.7;
  }

  & .b {
    fill: none;
  }

  & .c {
    stroke: #fff;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
    stroke-width: 2px;
  }

  display: inline-block;
  vertical-align: sub;
`;
